
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'footer': {'position': `relative`,'right': `0`,'bottom': `0`,'left': `0`,'height': `6.5rem`,'display': `flex`,'flexDirection': `row`,'alignItems': `center`,'justifyItems': `center`,'padding': `1% 8%`,'backgroundColor': `#000000`,},'footerContent': {'display': `flex`,'flexDirection': `column`,'width': `100%`,'alignItems': `center`,},'optionsStyle': {'display': `flex`,'flexDirection': `row`,'alignItems': `center`,},'optionsText': {'color': `#ffffff`,'marginBottom': `12px`,'fontFamily': `'Lato-Regular-Regular', sans-serif`,},'copyrightText': {'color': `#9b9b9b`,'fontFamily': `'Lato-Regular-Regular', sans-serif`,},
        
      };
    };
  